import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { LegalTask } from "../showPurchaseOrder/LegalTask";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { ILogin } from "../../models/Login";

interface IProps {
    open: boolean,
    req_ID: number,
    singleData: any,
    toast: any,
    hideDialog: () => void;
}

export const LegalTaskForm = (props: IProps) => {
    const [legalModal, setLegalModal] = useState({ type: "" } as { type: string });
    const [modal, setModal] = useState({ open: false, type: "", singleData: {} });

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
    const DateFormat = loginObj?.date_Format;

    const loadTableData = async (reqID: number) => {
    }

    useEffect(() => {
        if (props.open && props.req_ID) {
            loadTableData(props.req_ID);
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: "80vw" }} header="Create Task" className="p-fluid" onHide={() => props.hideDialog()}>
            {/* <DataTable value={[modal.singleData]} className="mb-3" showGridlines size="small">
                <Column field="company_Name_Sales" header="Company Name" />
                <Column field="salesmanager" header="Sales Manager" />
                <Column field="sales_Company_Branch" header="Sales Comp (Branch)" />
                <Column field="user_Name" header="Recuriter" />
                <Column field="recruiter_Company_Branch" header="Recruiter Comp (Branch)" />
                <Column field="consultant_Name" header="Consultant" />
                <Column field="company_Name_Sales" header="Company" />
                <Column field="pO_Status" header="Status" body={r => r.pO_Status ? POStatusMap[r.pO_Status] : ''}/>
                <Column field="pO_Date1" header="PO Date" style={{ minWidth: "100px" }} body={(rowData: any) => safeFormatDate(rowData.pO_Date1, "dd/MM/yyyy", DateFormat)} />
                <Column header="Start Date" body={(rowData: any) => safeFormatDate(rowData.project_Start_Date1, "dd/MM/yyyy", DateFormat)} />
                <Column header="End Date" body={(rowData: any) => safeFormatDate(rowData.project_End_Date, "dd/MM/yyyy", DateFormat)} />
            </DataTable> */}
            {/* <div>
                <label>Create Task For Document Type</label>
                <Dropdown value={legalModal.type} onChange={(e) => setLegalModal({ type: e.value })} options={[{ name: "--Select--" }, { name: "Consultant" }, { name: "Client" }, { name: "Vendor" }]} optionLabel="name" optionValue="name" placeholder="Select a Document Type" className="w-full md:w-14rem" />
            </div>
            <div className="mt-2"></div> */}
            {/* {legalModal.type.trim() !== "" && legalModal.type.trim() !== "--Select--" && <LegalTask sourceType="REQ" open={modal.open} type={legalModal.type} hideDialog={() => {
                setModal({ open: false, type: "", singleData: {} });
                loadTableData(props?.req_ID || 0);
            }} req_Id={props.singleData.req_ID || 0} toast={props.toast} is_form={false} hideDialogAb={() => { }} />} */}
            <LegalTask sourceType="REQ" open={props.open} type={legalModal.type} hideDialog={() => {
                // setModal({ open: false, type: "", singleData: {} });
                props.hideDialog();
                // loadTableData(props?.req_ID || 0);
            }} req_Id={props.singleData.req_ID || 0} toast={props.toast} is_form={false} hideDialogAb={() => { }} />
        </Dialog>
    );
}